/**
 * Zeigt und versteckt den Taschenrechner auf der Seite
 * @class service_v3sCalculator
 * @memberOf v3sWbtPlayerApp:page
 */

angular.module('v3sWbtPlayerApp').factory('v3sCalculatorService', ["$popover", "v3sI18nService", "$document", "$rootScope", function ($popover, v3sI18nService, $document, $rootScope) {

    var popover = false;
    var popovers = [];

    function show(actor, updateCallback) {
        var actorelement = angular.element(document.querySelector("#" + actor));
        var popoverOptions = {
                viewport: "#page-view",
                templateUrl: "app/js/page/v3sCalculator.tpl.html",
                controller: popoverController,
                placement: "auto right",
                content: "",
                controllerAs: "vm",
                locals: {
                    updateCallback: updateCallback
                },
                show: false,
                autoClose: true
            }

        if (!popovers[actorelement.attr("id")]) {
            popover = popovers[actorelement.attr("id")] = $popover(actorelement, popoverOptions);
        } else {
            //gibt es das Element nicht - dann wurde die seite zwischendurch verlassen...
            if (popovers[actorelement.attr("id")].$element != null) {
                popover = popovers[actorelement.attr("id")] = $popover(actorelement, popoverOptions);
            }
        }
        popovers[actorelement.attr("id")].$promise.then(popovers[actorelement.attr("id")].show);
    }

    function hide() {
        popover.$promise.then(function(){
            popover.hide();
            popover.destroy();
            popover = null;
        });
    }

    popoverController.$inject = ["$scope"];

    function popoverController($scope) {
        var vm = this;
        vm.result = popover.$options.locals.result || 0;
        vm.calculation = popover.$options.locals.calculation || "";
        vm.input = "";
        vm.history = [];
        vm.containsPercent = false;

        vm.justDoneMath = (vm.calculation == "") ? false : true;

        var culture = v3sI18nService.getCulture();
        vm.decimalSeperator = culture.numberFormat["."];

        popover.$scope.$on("tooltip.hide", function () {
            if (typeof popover.$options.locals.updateCallback == "function") {
                popover.$options.locals.updateCallback(vm.result, true);
            }


            //Wenn der Popover versteckt wird, soll der Eventhandler auch "detached" werden
            $document.off("keyup", keypressHandler);

            popover.$options.locals.calculation = vm.calculation;
            popover.$options.locals.result = vm.result;
        })
        popover.$scope.$on("destroy", function (evt) {
            console.log("murder");
        })



        this.add = function (n) {
            //Letzten Eintrag holen

            var last = null;
            if (vm.isOperator(n)) {
                if (vm.history.length == 0 && vm.input == "" && !vm.justDoneMath) {
                    //Operatoren dürfen nicht als erstes geschrieben werden
                    return;
                }else if(this.history.length > 0){
                    //Wenn ein Operator eingegeben wurde, soll dieser ggf. den letzten Operator ersetzen
                    // -> last wird nicht mehr hinzugefügt
                    last = this.history[this.history.length -1 ];
                    if (vm.input == "" && vm.isOperator(last)) {
                        this.history.pop()
                    }
                } else if(vm.justDoneMath) {
                    //Es soll weiter gerechnet werden
                    vm.history.push(vm.result);
                    vm.justDoneMath = false;
                }
            } else {
                if (vm.justDoneMath) {
                    vm.justDoneMath = false;
                }
            }

            //Es darf nur einen Punkt geben
            if (n == vm.decimalSeperator) {
                if (this.input.indexOf(vm.decimalSeperator) != -1) {
                    return;
                }
            }

            //Wenn es ein Operator ist, dann wird der input gespeichert
            if (this.isOperator(n)) {
                //Bei Prozent gehört der Operator zum input!
                if (n != "%") {
                    if (this.input != "") this.history.push(this.input);
                    this.history.push(n);
                    this.input = "";
                }else{
                    this.containsPercent = true;
                    this.input += n;
                    this.history.push(this.input);
                    this.input = "";
                }
            } else {
                this.input += n;
            }

            this.writeCalculation();
        }


        this.resetMemory = function () {
            this.memory = 0;
        }

        this.changeSign = function () {
            if (this.input.indexOf("-") == -1) {
                this.input = "-".concat(this.input);
            } else {
                this.input = this.input.substr(1);
            }
            this.writeCalculation();
        }

        this.isOperator = function (n) {
            if (isNaN(n)) {
                if (n != vm.decimalSeperator) {
                    return true;
                }
            }
            return false;
        }

        this.writeCalculation = function () {
            this.calculation = this.history.join('') + this.input;
        }

        this.doMath = function () {
            var self = this;
            //Wenn Prozentrechnung enthalten ist, müssen teilbereiche von hand gerechnet werden
            if (self.containsPercent) {
                //Alle Prozentberechnungen finden
                var indices = [];
                angular.forEach(self.history, function (h, $index) {
                    if (h.indexOf('%') != -1) {
                        //Stelle merken
                        indices.push(h);

                        //Prozentzeichen löschen
                        h.replace("%", "");
                    }
                });

                angular.forEach(indices, function (val,$index) {
                    //idx muss immer neu gesetzt werden, da this.history evtl beschnitten wird...
                    var idx = self.history.indexOf(val);
                    //Checken welcher Operator vor dem Prozentausdruck steht
                    if (!!self.history[idx - 1]) {
                        //Wenn der Operator davor "/" oder "x" ist, wird einfach x/100 gerechnet
                        if (self.history[idx - 1] == "/" || self.history[idx - 1] == "*") {
                            self.history[idx] = parseInt(self.history[idx]) / 100

                        // "+" "-"
                        } else {
                            var start = ($index == 0) ? 0 : indices[$index - 1];
                            var end = idx - 1;
                            //Die Formel vor dem Prozentsatz
                            var calc = self.history.slice(start, end);
                            var lastIndexOfDivide = calc.indexOf("/");
                            var lastIndexOfMulti = calc.indexOf("*");

                            var lastOperatorIsDivideOrMulti = (lastIndexOfDivide > 0 && lastIndexOfDivide == calc.length - 2 || lastIndexOfMulti > 0 && lastIndexOfMulti == calc.length - 2);

                            if (lastOperatorIsDivideOrMulti) {
                                self.history.splice(start, end, eval(calc.join('')));
                                //idx neusetzen...
                                idx = self.history.indexOf(val);
                                self.history[idx] = parseInt(self.history[start]) / 100 * parseInt(self.history[idx]);
                            } else {
                                if (self.history[idx - 2]) {
                                    self.history[self.history.indexOf(val)] = parseInt(self.history[idx - 2]) / 100 * parseInt(self.history[idx]);
                                }
                            }

                        }
                    }

                })

            }


            self.writeCalculation();

            //Es kann nur mit Punkten als Trennzeichen gerechnet werden

            //Der Regex-Ausdruck um alle decimaltrenner zu finden
            var regEx = (vm.decimalSeperator == ".") ? new RegExp("\\.","g") :  new RegExp(vm.decimalSeperator, "g");
            //Das Ergebnis
            if (self.calculation != "") {
                var result = eval(self.calculation.replace(regEx, "."));
                //Das anzuzeigende Ergebnis mit ersetzten Punkten
                self.result = result.toString().replace(/\./g, vm.decimalSeperator);
                self.justDoneMath = true;
            }

            self.history = [];
            self.input = "";

            if (popover.$options.locals.updateCallback && typeof popover.$options.locals.updateCallback === "function") {
                popover.$options.locals.updateCallback(self.result, false);
            }

        }

        this.resetAll = function () {
            this.result = 0;
            this.input = "";
            this.calculation = "";
            this.history = [];
        }

        //Falls vm.calculation nicht leer ist, muss die history neu geschrieben werden
        if (vm.calculation != "") {
            var inputs = vm.calculation.split("");
            angular.forEach(inputs, function (input) {
                vm.add(input);
            })
        }

        //Der KeyboardHandler...
        function keypressHandler(event) {
            var code = event.which;
            if (event.shiftKey) {
                if (code == 53) {
                    vm.add("%");
                } else if (code == 55) {
                    vm.add("/")
                } else if (code == 48) {
                    vm.doMath();
                }
            } else {
                if (47 < code && code < 58) {
                    vm.add(code - 48);
                } else if (95 < code && code < 106) {
                    vm.add(code - 96);
                }else if(code == 187 || code == 107){
                    vm.add("+");
                } else if (code == 189 || code == 109) {
                    vm.add("-");
                } else if (code == 111 || code == 191) {
                    vm.add("/");
                } else if (code == 106) {
                    vm.add("*");
                }else if(code == 165){
                    vm.add("%");
                } else if (code == 188 || code == 190 || code == 110) {
                    vm.add(vm.decimalSeperator);
                } else if (code == 13) {
                    vm.doMath();
                } else if (code == 27) {
                    vm.resetAll();
                }
            }

            $scope.$apply();
        }
        $document.bind("keyup", keypressHandler)

        $rootScope.$on('$stateChangeStart', function () {
            popover.destroy();
            popovers = [];
        });
    }
    return {
        show: show,
        hide : hide
    }
}]);